var _style, _rect, _g, _path, _path2, _path3, _rect2, _path4, _path5, _polygon, _polygon2, _path6, _path7, _path8, _defs, _polygon3, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4CardColorHorizontal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1__x28_1:1_x29_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 304 74",
    style: {
      enableBackground: "new 0 0 304 74"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#FCB316;}\r\n\t.st2{fill:#10357F;}\r\n\t.st3{fill:#EF7622;}\r\n\t.st4{fill:#231F20;}\r\n\t.st5{clip-path:url(#SVGID_2_);fill:url(#SVGID_3_);}\r\n\t.st6{opacity:0;}\r\n\t.st7{fill:#FF5F00;}\r\n\t.st8{fill:#EB001B;}\r\n\t.st9{fill:#F79E1B;}\r\n\t.st10{fill:#0071CE;}\r\n\t.st11{fill:#E4EDF6;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st11",
    width: 304,
    height: 74
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 159.4,
    y: 19,
    className: "st0",
    width: 56.6,
    height: 36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.4,
    y: 49.1,
    className: "st1",
    width: 54.7,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.4,
    y: 20,
    className: "st2",
    width: 54.7,
    height: 4.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M182.3,30.3l-5.7,13.5h-3.7L170.1,33c0-0.5-0.4-1-0.8-1.2c-1.1-0.5-2.3-0.9-3.4-1.1l0.1-0.4h5.9 c0.8,0,1.5,0.6,1.6,1.4l1.5,7.8l3.6-9.2C178.6,30.3,182.3,30.3,182.3,30.3z M196.7,39.4c0-3.6-4.9-3.8-4.9-5.3c0-0.5,0.5-1,1.5-1.1 c1.2-0.1,2.4,0.1,3.4,0.6l0.6-2.9c-1-0.4-2.2-0.6-3.3-0.6c-3.4,0-5.9,1.8-5.9,4.5c0,1.9,1.7,3,3.1,3.7s1.8,1.1,1.8,1.7 c0,0.9-1.1,1.3-2.1,1.3c-1.2,0-2.5-0.3-3.6-0.8l-0.6,3c1.2,0.5,2.6,0.7,3.9,0.7C194.3,44,196.7,42.2,196.7,39.4 M205.9,43.8h3.2 l-2.8-13.5h-3c-0.7,0-1.2,0.4-1.5,1l-5.2,12.5h3.7l0.7-2h4.5L205.9,43.8z M202,39l1.8-5.1l1.1,5.1H202z M187.3,30.3l-2.9,13.5h-3.5 l2.9-13.5L187.3,30.3z"
  }))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M285,38.9c0,0-14.8,10.5-42,15.2h42V38.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M285.2,19.5h-54.5v35h54.7v-35H285.2z M285,19.9v34.2h-53.9c0-0.4,0-33.8,0-34.2H285z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M235.5,30.2h-2.3v7.9h2.2c1,0.1,2.1-0.3,2.9-0.9c0.9-0.7,1.4-1.8,1.4-3c0-2.2-1.7-4-3.8-4 C235.8,30.2,235.6,30.2,235.5,30.2z M237.3,36.2c-0.6,0.5-1.4,0.7-2.1,0.6h-0.4v-5.3h0.4c0.8-0.1,1.5,0.2,2.1,0.6 c0.6,0.5,0.9,1.2,0.9,2C238.2,35,237.9,35.7,237.3,36.2z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 240.4,
    y: 30.2,
    className: "st4",
    width: 1.5,
    height: 7.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M245.7,33.2c-0.9-0.3-1.2-0.6-1.2-1s0.5-0.9,1.1-0.9c0.5,0,0.9,0.2,1.2,0.6l0.8-1.1c-0.6-0.6-1.5-0.9-2.3-0.9 c-1.3-0.1-2.4,0.9-2.5,2.2v0.1c0,1.1,0.5,1.7,1.9,2.2c0.4,0.1,0.7,0.3,1.1,0.5c0.3,0.2,0.5,0.5,0.5,0.8c0,0.6-0.5,1.1-1.1,1.1 c0,0,0,0-0.1,0c-0.7,0-1.4-0.4-1.7-1.1l-1,1c0.6,1,1.6,1.5,2.8,1.5c1.4,0.1,2.6-1,2.7-2.4c0-0.1,0-0.2,0-0.2 C248,34.5,247.5,33.9,245.7,33.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M248.5,34.2c0,2.3,1.8,4.1,4.1,4.1h0.1c0.7,0,1.3-0.2,1.9-0.5V36c-0.5,0.5-1.1,0.9-1.9,0.9 c-1.4,0-2.6-1.1-2.7-2.5c0-0.1,0-0.1,0-0.2c0-1.5,1.1-2.7,2.5-2.7c0,0,0,0,0.1,0c0.7,0,1.5,0.3,1.9,0.9v-1.9 c-0.6-0.3-1.2-0.5-1.9-0.5C250.4,30,248.5,31.8,248.5,34.2L248.5,34.2z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "266.9,35.5 264.8,30.2 263.1,30.2 266.4,38.3 267.3,38.3 270.7,30.2 269,30.2  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "271.4,38.1 275.8,38.1 275.8,36.8 272.9,36.8 272.9,34.7 275.7,34.7 275.7,33.3 272.9,33.3  272.9,31.6 275.8,31.6 275.8,30.2 271.4,30.2  "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M281.9,32.5c0-1.5-1-2.3-2.8-2.3h-2.3v7.9h1.5v-3.2h0.2l2.1,3.2h1.9l-2.5-3.3C281.2,34.6,282,33.7,281.9,32.5z  M278.8,33.9h-0.5v-2.4h0.5c1,0,1.5,0.4,1.5,1.2S279.8,33.9,278.8,33.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M283,30.6c0-0.1-0.1-0.2-0.3-0.2h-0.2v0.7h0.2v-0.3l0.2,0.3h0.2l-0.2-0.3C282.9,30.8,283,30.7,283,30.6z  M282.7,30.7L282.7,30.7v-0.2l0,0c0.1,0,0.1,0,0.1,0.1S282.8,30.7,282.7,30.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M282.7,30.1c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6c0.3,0,0.6-0.3,0.6-0.6l0,0 C283.3,30.4,283.1,30.1,282.7,30.1L282.7,30.1z M282.7,31.2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5l0,0 C283.2,31,283,31.2,282.7,31.2L282.7,31.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M255.2,34.3c0,2.3,1.9,4.2,4.2,4.2s4.2-1.9,4.2-4.2s-1.9-4.2-4.2-4.2C257,30.1,255.2,32,255.2,34.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -2398.8782,
    y1: 118.3307,
    x2: -2398.4338,
    y2: 118.3307,
    gradientTransform: "matrix(-6.5095 -10.1919 10.1919 -6.5095 -16560.0156 -23641.2422)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2345,
    style: {
      stopColor: "#F49A01"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4995,
    style: {
      stopColor: "#F28D04"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6196,
    style: {
      stopColor: "#F18406"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7552,
    style: {
      stopColor: "#EF7B09"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED6F0D"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "267.3,36 261.1,26.3 251.4,32.5 257.6,42.2  "
  })))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.4,
    y: 18.3,
    className: "st0",
    width: 56.6,
    height: 37.4
  })), /*#__PURE__*/React.createElement("rect", {
    x: 110.2,
    y: 24.8,
    className: "st7",
    width: 14.9,
    height: 24.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M111.7,37c0-4.8,2.2-9.3,5.9-12.2c-6.7-5.3-16.5-4.1-21.8,2.6s-4.1,16.5,2.6,21.8c5.6,4.4,13.5,4.4,19.2,0 C113.9,46.2,111.7,41.7,111.7,37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M141.3,46.6v-0.5h0.2V46H141v0.1h0.2L141.3,46.6L141.3,46.6z M142.3,46.6V46h-0.2l-0.2,0.4l-0.2-0.4h-0.2v0.6 h0.1v-0.5l0.2,0.4h0.1l0.2-0.4v0.5H142.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M142.7,37c0,8.6-6.9,15.5-15.5,15.5c-3.5,0-6.9-1.2-9.6-3.3c6.7-5.3,7.9-15,2.6-21.8c-0.8-1-1.6-1.8-2.6-2.6 c6.7-5.3,16.5-4.1,21.8,2.6C141.6,30.1,142.7,33.5,142.7,37L142.7,37z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M68.6,50.7l-2.5-2.7l-2.5,2.7h-4.9l0,0H48.2V38.2h-5l6.2-14.1h6l2.2,4.8v-4.8H65l1.3,3.7l1.3-3.7h5.7v-2.2 c0-1.3-1.1-2.3-2.3-2.3H21c-1.3,0-2.3,1.1-2.3,2.3v30.3c0,1.3,1.1,2.3,2.3,2.3h50c1.3,0,2.3-1.1,2.3-2.3v-1.5H68.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "69.3,49.3 73.3,49.3 68.1,43.8 73.3,38.3 69.4,38.3 66.2,41.8 63,38.3 59.1,38.3 64.3,43.8  59.1,49.3 62.9,49.3 66.1,45.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "52.8,46.8 52.8,45.1 59,45.1 59,42.6 52.8,42.6 52.8,40.8 59.1,40.8 59.1,38.3 49.8,38.3  49.8,49.3 59.1,49.3 59.1,46.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "70.3,36.8 73.2,36.8 73.2,25.8 68.7,25.8 66.2,32.6 63.8,25.8 59.1,25.8 59.1,36.8 62.1,36.8  62.1,29.1 64.9,36.8 67.5,36.8 70.3,29.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M54.3,25.8h-3.8l-4.8,10.9H49l0.9-2.2h5l0.9,2.2h3.4L54.3,25.8z M50.8,32.1l1.5-3.6l1.5,3.6H50.8z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "70.5,43.5 73.3,46.5 73.3,40.5  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4CardColorHorizontal);
export default __webpack_public_path__ + "static/media/4_Card_color_horizontal.f470b29db2c3e669000ac9a10f112af4.svg";
export { ForwardRef as ReactComponent };